import { Chip } from '@mui/material';
import { camelize } from 'helpers/syntaxHelper';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import { MANTY_GREEN, MANTY_ORANGE, MANTY_CYAN, MANTY_RED } from 'styles/theme';
import { ClientGridT } from '../ClientsGrid/model';

const modulesColor: { [key: string]: string } = {
    decision: MANTY_ORANGE,
    budget: MANTY_CYAN,
    human_resources: MANTY_GREEN,
    backoffice: MANTY_RED,
};

export function ModulesCellRenderer({ data }: CellRendererParams<ClientGridT>) {
    const { t } = useTranslation();
    if (!data) return <></>;
    return _.sortBy(data.modules).map((e: string) => (
        <Chip
            key={e}
            variant="outlined"
            sx={{
                color: modulesColor[e],
                borderColor: modulesColor[e],
                borderRadius: 2,
                margin: '2px',
            }}
            label={t(`modules.${camelize(e)}`)}
        />
    ));
}
